
import * as ipxStaticRuntime$kdqzn7V88LPeVH_EHNC4WMRUeSz7bTSFOwtnlQHTVVY from '/home/leandro/_git/baeta-advocacia/node_modules/.pnpm/@nuxt+image@1.10.0_@netlify+blobs@8.2.0_db0@0.3.2_better-sqlite3@11.9.1__ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipxStatic']: { provider: ipxStaticRuntime$kdqzn7V88LPeVH_EHNC4WMRUeSz7bTSFOwtnlQHTVVY, defaults: {} }
}
        